/**
 * Common Ethereum network IDs
 */

/** @type {import('./NetworkIdType.js').NetworkIdType} */
export const MAINNET =
	/** @type {import('./NetworkIdType.js').NetworkIdType} */ (1);

/** @type {import('./NetworkIdType.js').NetworkIdType} */
export const GOERLI =
	/** @type {import('./NetworkIdType.js').NetworkIdType} */ (5);

/** @type {import('./NetworkIdType.js').NetworkIdType} */
export const SEPOLIA =
	/** @type {import('./NetworkIdType.js').NetworkIdType} */ (11155111);

/** @type {import('./NetworkIdType.js').NetworkIdType} */
export const HOLESKY =
	/** @type {import('./NetworkIdType.js').NetworkIdType} */ (17000);
